export enum TaskStateEnum {
    New = 1,
    Inprogress,
    Overdue,
    Completed
}